<template>
  <div class="content-background" v-loading="isShowLoading">
    <div class="content-mode">
      <div class="header">
        <div class="left" @click="changeTap(AttachmentMediaTypeEnum.IMAGE.code)">
          <label class="label" :class="{'selected-label': mediaType === AttachmentMediaTypeEnum.IMAGE.code }">图文模式</label>
          <p class="icon" v-if="mediaType === AttachmentMediaTypeEnum.IMAGE.code"></p>
        </div>
        <div class="right" @click="changeTap(AttachmentMediaTypeEnum.VIDEO.code)">
          <label class="label" :class="{'selected-label': mediaType === AttachmentMediaTypeEnum.VIDEO.code }">视频模式</label>
          <p class="icon" v-if="mediaType === AttachmentMediaTypeEnum.VIDEO.code"></p>
        </div>
      </div>
      <div class="divider-container">
        <div class="content-divider"></div>
      </div>
    </div>
    <div class="add-content">
      <div class="content">
        <div class="content-title">
          <p class="content-label">标题</p>
          <el-input
            v-model="title"
            placeholder="请输入标题"
            type="text"
            class="content-title-input"
            maxlength="20" :show-word-limit="true"></el-input>
            <span class="limit">{{title? title.length: 0}}/20</span>
        </div>
        <div class="content-cover" v-if="mediaType === AttachmentMediaTypeEnum.VIDEO.code">
          <p class="content-label">封面</p>
          <div v-if="coverImage&&coverImage.src" class="content-cover-image">
            <img class="content-cover-button" :src="coverImage.src | ossImageProcess">
            <el-button type="text"
              @click="handleRemoveCover"
              icon="icon-remove-image"
              class="image-remove-icon"></el-button>
          </div>
          <el-button
            v-else
            type="text"
            @click="handleCoverChange"
            class="content-cover-button"
            icon="icon-add-cover"></el-button>
        </div>
        <div class="content-image">
          <p class="content-label">内容素材</p>
            <div class="content-image-list">
              <div v-for="(item, index) in displayImages" v-bind:key="item" class="content-image-item">
                <img class="content-cover-button" :src="item.src | ossImageProcess">
                <el-button type="text"
                  @click="handleRemoveContentImage(index)"
                  icon="icon-remove-image"
                  class="image-remove-icon"></el-button>
              </div>
                <el-button v-if="images.length < 9 && mediaType === AttachmentMediaTypeEnum.IMAGE.code"
                  class="content-image-add"
                  icon="icon-add-image"
                  @click="handleContentImageChange"
                ></el-button>
                <el-button v-if="videoImages.length < 1 && mediaType === AttachmentMediaTypeEnum.VIDEO.code"
                  class="content-image-add"
                  icon="icon-add-image"
                  @click="handleVideoChange"
                ></el-button>
            </div>
            <p class="content-label" style="margin-bottom: 0">正文</p>
            <div class="content-area">
              <el-input
                v-model="content"
                type="textarea"
                :rows="7"
                class="content-image-input"
                placeholder="请输入正文内容">
              </el-input>
            </div>
        </div>
        <div class="content-publish">
          <div style="width: 200px;">
            <p class="content-label">圈子</p>
            <el-select :disabled="isEdit" class="post-list-filter-value" placeholder="请选择圈子" v-model="circleId" @change="onChangeCircleId" clearable filterable size="small">
              <el-option
                v-for="item in circleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="content-topic-divider"></div>
          <div class="content-footer">
            <el-button class="publish" @click="savePost(bannedTypeEnum.UNBANNED.value)">立即发布</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import '@/styles/content.scss'
  import { createPost, updatePost, getPost } from '@/api/post/post';
  import { getCircleNames } from '@/api/post/circle'
  import AttachmentMediaTypeEnum from '@/common/enums/AttachmentMediaTypeEnum';
  import * as util from '@/util/util';
  import tencentVodService from  '@/common/common-logic/tencentVod';
  import tencentCloud from '@/api/basic/tencent-cloud';
  import postTypeEnum from '@/common/enums/postTypeEnum';
  import bannedTypeEnum from '@/common/enums/bannedTypeEnum';
  import uploadService from '@/common/common-logic/upload-service';

  export default {
    data() {
      return {
        timeout: null,
        post: '',
        content: '',
        title: '',
        id: '',
        url: '',
        coverImage: null,
        images: [],
        videoImages: [],
        mediaType: AttachmentMediaTypeEnum.IMAGE.code,
        video: null,
        isShowLoading: false,
        isEdit: false,
        AttachmentMediaTypeEnum,
        circleId: '',
        showMaterialSelector: false,
        bannedTypeEnum,
        circleOptions: [],
      }
    },
    computed: {
      displayImages() {
        if (this.mediaType === AttachmentMediaTypeEnum.IMAGE.code) {
          return this.images;
        } else if (this.mediaType === AttachmentMediaTypeEnum.VIDEO.code) {
          return this.videoImages;
        }
        return [];
      },
    },
    methods: {
      // 获取圈子下拉列表
      async getCircleNamesOptionse() {
        const response = await getCircleNames();
        if (Array.isArray(response.data.data)) {
          const circleNames = response.data.data.map(x => {
            return {
              value: x.id,
              label: x.circleName
            }
          });
          this.circleOptions = this.circleOptions.concat(circleNames);
        }
      },
      changeTap(mediaType) {
        this.mediaType = mediaType
      },
      handleCoverChange () {
        this.$openMaterialLib((list) => {
          if (!list || list.length === 0) {
            return;
          }

          this.coverImage = {
            src: list[0].contentUrl,
            url: list[0].contentUrl,
          }
        }, 1);
      },
      handleImageChange (file, fileList, isCover) {
        if (!file) {
          return;
        }

        var image = { src: util.getObjectURL(file.raw), file: file.raw, id: util.getUUid() }
        this.images.push(image)
      },
      handleRemoveCover () {
        if (this.coverImage.src) {
          window.URL.revokeObjectURL(this.coverImage.src);
          this.coverImage = null;
        }
      },
      handleContentImageChange (file, fileList) {
        this.$openMaterialLib((list) => {
          if (!list || list.length === 0) {
            return;
          }
          list.forEach(item => {
            if (this.images.length >= 9) {
              return;
            }

            this.images.push({
              src: item.contentUrl,
              url: item.contentUrl,
            })
          });
        }, 9 - this.images.length);
      },
      handleRemoveContentImage (index) {
        if (this.mediaType === AttachmentMediaTypeEnum.IMAGE.code) {
          this.images.splice(index, 1)
        }

        if (this.mediaType === AttachmentMediaTypeEnum.VIDEO.code) {
          const image = this.videoImages[index];
          this.videoImages.splice(index, 1);
          this.coverUrl = ''
          window.URL.revokeObjectURL(image.src);
          window.URL.revokeObjectURL(this.video.src);
          this.video = null;
        }
      },
      async handleVideoChange(elefile, fileList) {
        this.$openMaterialLib((list) => {
          if (!list || list.length === 0) {
            return;
          }
          this.videoImages.push({
            src: list[0].coverUrl,
            url: list[0].coverUrl
          })

          this.video = {
            url: list[0].contentUrl
          };
        }, 1, 'video');
      },
      async savePost (isBanned) {
        try {
          if (this.mediaType === AttachmentMediaTypeEnum.IMAGE.code) {
            if (this.images.length === 0) {
              this.$message({
                message: '请选择内容素材',
                type: 'error'
              })
              return;
            }
          } else if (this.mediaType === AttachmentMediaTypeEnum.VIDEO.code) {
            if (this.video === null) {
              this.$message({
                message: '请选择内容素材',
                type: 'error'
              })
              return;
            }
          }
          if (this.circleId === ''){
            this.$message({
                message: '请选择圈子',
                type: 'error'
              })
              return;
          }

          this.isShowLoading =  true;
          let coverUrl = '';
          if (this.mediaType === AttachmentMediaTypeEnum.IMAGE.code) {
            coverUrl = this.images[0].url;
          } else {
            if (this.coverImage && this.coverImage.url) {
              coverUrl = this.coverImage.url;
            } else {
              coverUrl = this.videoImages[0].url;
            }
          }

          var postData = {
            title: this.title,
            contentType: 0,
            content: this.content,
            circleId: this.circleId,
            coverImg: coverUrl,
            isBanned: isBanned,
            banComment: "",
            publishStatus: 1,
            postTags: [],
            postType: this.mediaType === AttachmentMediaTypeEnum.IMAGE.code ? 0 : 1, // 0 帖子 1 视频
          }

          if (this.mediaType === AttachmentMediaTypeEnum.IMAGE.code) {
            postData.attachments = this.images.map((item) => ({
              thumbnailUrl: item.url,
              attachmentUrl: item.url,
              mediaType: AttachmentMediaTypeEnum.IMAGE.code,
            }));
          } else if(this.mediaType === AttachmentMediaTypeEnum.VIDEO.code) {
            if (!this.video.url) {
              const vodSignature = await this.requestWrapper(tencentCloud.getVodSign);
              if (!vodSignature || vodSignature.ok === false) {
                this.$message({
                  message: '暂不支持此格式',
                  type: 'error'
                })
                throw new Error('获取vod签名失败');
              }

              const uploadVideoResponse = await tencentVodService.uploadVideo(this.video.file, vodSignature);
              this.video.url = uploadVideoResponse.url;
              this.video.fileId =  uploadVideoResponse.fileId;
            }

            postData.attachments = [{
              thumbnailUrl: coverUrl,
              attachmentUrl: this.video.url,
              convertStreamUrl: this.video.convertStreamUrl,
              mediaType: AttachmentMediaTypeEnum.VIDEO.code,
              fileId: this.video.fileId
            }];
          }

          let saveResult = null;
          if (this.isEdit) {
            postData.id = this.id;
            saveResult = await this.requestWrapper(updatePost, postData)
          } else {
            saveResult = await this.requestWrapper(createPost, postData)
          }

          if (!saveResult || saveResult.ok === false || saveResult.code !== 0) {
            this.$message({
              message: saveResult.message || '保存失败',
              type: 'error'
            })
            throw new Error('保存失败');
          }

          this.$message({
            message: isBanned === bannedTypeEnum.BANNED.value ? '保存成功' : '发布成功',
            type: 'success'
          })
          this.$router.back();
        } catch (error) {
          this.isShowLoading =  false;
          console.error(error);
        }
      },
      async init () {
        const postResponse = await this.requestWrapper(getPost, this.$route.query.id);
        if (!postResponse || postResponse.ok === false || postResponse.code !== 0) {
          vm.$message({
            showClose: true,
            message: '未查询到该帖子',
            type: 'error'
          });
        }
        const post = postResponse.data;
        this.circleId = post.circleId;
        this.title = post.title;
        this.content = post.content;
        this.id = post.id;

        if (post.postType === postTypeEnum.IMAGE) {
          this.mediaType = AttachmentMediaTypeEnum.IMAGE.code;
          this.images = post.attachments.map(item => {
            return {
              src: item.attachmentUrl,
              url: item.attachmentUrl
            }
          });
        } else if (post.postType === postTypeEnum.VIDEO) {
          this.mediaType = AttachmentMediaTypeEnum.VIDEO.code;
          this.coverImage = {
            src: post.coverImg,
            url: post.coverImg,
          }
          if (post.attachments.length > 0) {
            this.videoImages = post.attachments.map(item => {
              return {
                src: item.thumbnailUrl,
                url: item.thumbnailUrl
              }
            });

            this.video = {
              url: post.attachments[0].attachmentUrl,
              fileId: post.attachments[0].fileId,
              convertStreamUrl: post.attachments[0].convertStreamUrl,
            }
          }
        }
      },
    },
    mounted() {
      if(!this.$route.query) {
        this.$router.back();
        return;
      }

      if(this.$route.query.id && !isNaN(this.$route.query.id)) {
        this.isEdit = true;
        this.init();
      }

      this.getCircleNamesOptionse();
    }
  }
</script>

<style lang="scss" scoped>
.content-background {
  .content-mode {
    .icon {
      margin: 0;
      padding: 0;
      background-color: #5383f3;
      height: 2px;
      width: 32px;
      margin: auto;
      margin-top: 12px;
    }
    .header {
      display: flex;
      align-content: center;
      .label {
        margin: auto;
      }
      .left {
        margin-bottom: 0px;
        text-align: center;
        padding: 0px 40px;

      }
      .right {
        margin-bottom: 0px;
        text-align: center;
        padding: 0px 40px;
      }
    }
    .divider-container {
      padding: 0px 19px;
    }
  }
  .add-content {
    .limit {
      font-size: 14px;
      color: #AFAFAF;
      margin-left: 12px;
    }
    .content-area {
      width: 920px;
      position: relative;
      .content-image-input {
        width: 100%;
        position: relative;
      }
      .limit {
        position: absolute;
        bottom: 8px;
        right: 8px;
      }
    }
    .content-footer {
      text-align: right;
    }
  }
}
</style>
